import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
* Generated class for the RawPipe pipe.
*
* See https://angular.io/api/core/Pipe for more info on Angular Pipes.
*/
@Pipe({
	name: 'raw',
})
export class RawPipe implements PipeTransform {
	constructor(private sanitizer:DomSanitizer){
	}
	/**
	Bypassa la pulizia dell'HTML
	*/
	transform(value: string, ...args) {
		return this.sanitizer.bypassSecurityTrustHtml(value);
	}
}



// WEBPACK FOOTER //
// ./src/pipes/raw/raw.ts